import React from 'react';
import { CheckIcon, CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, TargetIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 minutos'], [TargetIcon, 'De 0K a 21K'], [CheckIcon, 'Todos los niveles']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-98" data-mp="129qv5nkuztox">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-accent/10 blur-[120px]" data-id="element-99" data-mp="xanra6gm7tij" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-100" data-mp="s9qanyb977j5">
        <div className="mb-5 inline-flex rounded-full border border-accent/30 bg-accent/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-accent-dark md:mb-6" data-id="element-101" data-mp="nczt16jsw3vm">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.4rem]" data-id="element-102" data-mp="381nwfdzkt162">
          🏃 Combo Completo Running 2026
        </h1>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Combo Completo Running 2026" data-id="element-103" data-mp="3o6kdjcmbi22h">
          <img className="w-full max-w-[860px] object-contain drop-shadow-[0_26px_44px_rgba(7,16,29,.32)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Running 2026 con sus 6 tomos y 5 bonos" data-id="element-104" data-mp="3e84rho25dizu" />
        </a>

        <p className="mx-auto max-w-4xl text-xl font-black uppercase leading-tight text-accent md:text-4xl" data-id="element-105" data-mp="2qhqudj4pgtye">
          De cero a 21K. Elegí tu objetivo y seguí qué hacer cada día.
        </p>

        <p className="mx-auto mt-5 max-w-2xl text-base font-semibold leading-relaxed text-slate-600 md:text-lg" data-id="element-106" data-mp="2hjyn92950sm3">
          Planificaciones completas para empezar a correr o seguir progresando, con días de
          entrenamiento, tiempos, distancias, descansos, fuerza, técnica y progresiones organizadas
          paso a paso.
        </p>

        <p className="mx-auto mt-4 flex max-w-2xl items-start justify-center gap-2 rounded-2xl border border-primary/15 bg-white px-5 py-3.5 text-left text-sm font-semibold leading-relaxed text-slate-600" data-id="element-107" data-mp="ibyo48aw4u02">
          <UsersIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-108" data-mp="1b1ffd2mry4up" />
          <span data-id="element-109" data-mp="1ayjep6jjl22k">
            <b className="text-ink" data-id="element-110" data-mp="1622jxthu7pgi">¿Sos profesor?</b> También incluye un sistema para evaluar,
            organizar y hacer progresar alumnos individuales o grupos de distintos niveles.
          </span>
        </p>

        <p className="mt-6 text-base font-black uppercase text-primary md:text-lg" data-id="element-111" data-mp="x1w8se9m31ki">
          Tu entrenamiento de running, organizado paso a paso. Desde hoy.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-112" data-mp="3hrdacyaa5g1h">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-113" data-mp="1x784bltydnt2">
              <BadgeIcon className="h-4 w-4 text-accent" data-id="element-114" data-mp="21bpm5fgr5r17" />
              {label}
            </span>)}
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-115" data-mp="268oblkph19t2">
          <span className="flex items-center gap-1" data-id="element-116" data-mp="2g02l8lb4zpzx">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-117" data-mp="2fzanb3u2hg6h" />
            Garantía 7 días
          </span>
          <span className="text-accent/40" data-id="element-118" data-mp="2kx2hy5m3jged">·</span>
          <span className="flex items-center gap-1" data-id="element-119" data-mp="2ozz0jwbmzcib">
            <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-120" data-mp="2oye6s8x5bxli" />
            Pago seguro
          </span>
          <span className="text-accent/40" data-id="element-121" data-mp="2txhczwov49v2">·</span>
          <span className="flex items-center gap-1" data-id="element-122" data-mp="un9axqsawpgq">
            <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-123" data-mp="uou359r57wbf" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-124" data-mp="4b47zvkw08ki">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-line bg-white p-4 text-center shadow-sm" data-id="element-125" data-mp="3vgni4u78vzrw">
              <p className="text-xl font-black text-primary md:text-2xl" data-id="element-126" data-mp="e77ibopw7dij">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-127" data-mp="98e4fv6p1khu">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}